module.exports = __webpack_public_path__ + "img/2000x1125-oscuro.9035d70b.jpg";